/* eslint-disable import/no-named-default */
import React, { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'animate.css/animate.min.css';
import { ConfigProvider } from 'antd';
import locale from 'antd/lib/locale/vi_VN';
import 'moment/locale/vi';
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route } from 'react-router-dom';

import 'assets/vendors/style';
import AuthProvider from 'store/providers/AuthProvider';
import { default as ConfigAppProvider } from 'store/providers/ConfigProvider';
import PosProvider from 'store/providers/PosProvider';
import 'styles/omini/omini.less';

import Loading from './components/Loading';
import App from './pages/App/index';

const queryClient = new QueryClient();
const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<App />} />));

function NextApp() {
  return (
    <ConfigProvider locale={locale}>
      <ConfigAppProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <PosProvider>
              <Suspense fallback={<Loading />}>
                <RouterProvider router={router} />
              </Suspense>
            </PosProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ConfigAppProvider>
    </ConfigProvider>
  );
}

export default NextApp;
